const $ = require('jquery');

const lottieAnimationCarousel = {

	init() {
		this.$el = $('.js-lottie-carousel .ult-content-box');
		if (this.$el.length > 0) {
			this.setup();
		}
	},
	setup() {
		this.lottieElementSetup();
		this.slickCarouselSetup();
	},


	lottieElementSetup() {
		$('.js-lottie-carousel .ult-content-box').on('init', function(event, slick, currentSlide){
			const init_slide = $(slick.$slides.get(currentSlide));
			const init_slide_url = init_slide.find('.js-lottie-carousel-player').attr('data-src');
			const init_slide_speed = init_slide.find('.js-lottie-carousel-player').attr('data-speed');
			const $init_player = $('<lottie-player class="rendered-lottie" src="' + init_slide_url + '" autoplay speed="' + init_slide_speed +'" mode="normal"></lottie-player>');

			init_slide.append($init_player);
			this.lottie_player = $init_player.get(0);
			this.lottie_player .pause();
		});


		$('.js-lottie-carousel .ult-content-box').on('beforeChange', function(event, slick, currentSlide, nextSlide ){
			var next_slide_dom = $(slick.$slides.get(nextSlide));
			next_slide_dom.find('.rendered-lottie').remove();
		});


		$('.js-lottie-carousel .ult-content-box').on('afterChange', function(event, slick, currentSlide ){
			const current_slide_dom = $(slick.$slides.get(currentSlide));
			const lottie_url = current_slide_dom.find('.js-lottie-carousel-player').attr('data-src');
			const lottie_speed = current_slide_dom.find('.js-lottie-carousel-player').attr('data-speed');
			const $c_player = $('<lottie-player class="rendered-lottie" src="' + lottie_url + '" autoplay speed="' + lottie_speed +'" mode="normal"></lottie-player>');
			current_slide_dom.append($c_player);
			this.lottie_player = $c_player.get(0);
			this.lottie_player.pause();
		});
	},
	slickCarouselSetup() {
		var js_lottie_carousel = $('.js-lottie-carousel .ult-content-box');
		js_lottie_carousel.slick({
			infinite: true,
			autoplay: false,
			fade: true,
			cssEase: 'linear',
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: true,
			rows: 0,

		});
	}
};

$(lottieAnimationCarousel.init.bind(lottieAnimationCarousel));
